import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from './sections/hero';
import AboutSection from './sections/about';
import ProcessSection from './sections/process';
import GamesSection from './sections/games';
import VideoSection from './sections/video';
import PartnersSection from './sections/partners';
import './styles/home.css';
import Footer from '../../../components/footer';
import Navbar from '../../../components/navbar';

function HomePage() {
  useEffect(() => {
    document.title = 'Cheda Gaming | Home';
  }, []);

  const siteTitle = 'Earn while hosting or playing online tournaments';
  const siteDescription = 'Built specifically to connect gamers all across Africa. Reimagining how gamers hosts, stream, play and earn from online tournaments.';
  const featuredImage = 'https://wallpaperaccess.com/full/8625450.jpg';

  return (
    <>
      <Helmet>
        <meta property="og:title" content={siteTitle} />
        <meta property="og:description" content={siteDescription} />
        <meta property="og:image" content={featuredImage} />
      </Helmet>

      <div className="home-page">
        <Navbar />
        <main className="home-content">
          <HeroSection />
          <AboutSection />
          <ProcessSection />
          <GamesSection />
          <VideoSection />
          <PartnersSection />
        </main>
        <Footer />
      </div>
    </>
  );
}

export default HomePage; 